<!--
* @Name：综合类认定申请审批供应商信息
* @Author: 王超
* @Date: 2024-12-16
-->
<template>
  <div>
    <hi-card v-for="(item, index) in dataList" :key="item.suppId" :row-index="index + 1">
      <van-row>
        <span>供应商编号：</span>
        <span>{{ item.suppId }}</span>
      </van-row>
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>供货品类：</span>
        <span>{{ item.catgName }}</span>
      </van-row>
      <van-row>
        <span>企业类型：</span>
        <span>{{ item.enterpriseType | dictFilter(enterPriseOptions) }}</span>
      </van-row>
      <van-row>
        <span>品类审批属性：</span>
        <span>{{ item.catgIdentifyMode | dictFilter(catgIdentifyModeOptions) }}</span>
      </van-row>
      <van-row>
        <span>最终结论：</span>
        <span>{{ item.conclusion | dictFilter(suppDomainResultOptions) }}</span>
      </van-row>
      <van-row>
        <van-button type="info" size="normal" @click="viewDetailsInfo(item)">详细信息</van-button>
      </van-row>
      <van-row v-if="editable">
        <van-button style="margin-top: 5px" type="info" size="normal" @click="reviewInfo(item)">评审</van-button>
      </van-row>
    </hi-card>
    <details-info
      v-if="detailsVisible"
      :details-visible="detailsVisible"
      :line-list="detailItem.suppDomainQualifyReviewList"
      @close-details-dialog="detailsVisible = false"
    />
    <review-info
      v-if="reviewInfoVisible"
      :details-visible="reviewInfoVisible"
      :main-model="reviewItem"
      @close-details-dialog="reviewInfoVisible = false"
      @review-success="reviewSuccess"
    />
  </div>
</template>

<script>
export default {
  name: 'MaterialDetails',
  components: {
    'details-info': () => import('./SupplierLineDetail'),
    'review-info': () => import('./SupplierReview')
  },
  data() {
    return {
      // 审批结果列表弹框是否显示
      detailsVisible: false,
      // 评审结论选择弹框是否显示
      reviewInfoVisible: false,
      // 审批结果列表数据
      detailItem: {},
      // 评审结论选择数据：需带入供应商部分信息进行展示
      reviewItem: {}
    }
  },
  props: {
    // 供应商列表
    dataList: {
      type: Array,
      default: () => []
    },
    // 会签节点可进行评审
    editable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 企业类型参照
    enterPriseOptions() {
      return this.$store.getters.dicts.enterprise_type
    },
    // 最终结论参照
    suppDomainResultOptions() {
      return this.$store.getters.dicts.supp_domain_qualify_result
    },
    // 品类审批参照
    catgIdentifyModeOptions() {
      return this.$store.getters.dicts.catg_identify_mode
    }
  },
  methods: {
    // 评审结果列表弹框显示
    viewDetailsInfo(item) {
      this.detailsVisible = true
      this.detailItem = item
    },
    // 评审结论选择弹框显示
    reviewInfo(item) {
      this.reviewInfoVisible = true
      this.reviewItem = item
    },
    // 评审成功后通知首页数据刷新
    reviewSuccess() {
      this.$emit('review-success')
    }
  }
}
</script>
